
import React, { useState } from 'react';
import { convertImageToPdf } from '../utils/imageToPdf';

const ImageToPDF = () => {
    const [file, setFile] = useState(null);
    const [converting, setConverting] = useState(false);
    const [error, setError] = useState('');
    const fileInputRef = React.useRef(null);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        setError('');
    };

    const handleConvert = async (e) => {
        // Blur the button to remove focus state
        if (e && e.target) {
            e.target.blur();
        }

        if (!file) {
            setError('Please select an image file first.');
            return;
        }

        if (!['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)) {
            setError("Invalid file type. Please upload a JPG or PNG image.");
            return;
        }

        setConverting(true);
        setError('');

        try {
            const pdfBlob = await convertImageToPdf(file);
            const url = URL.createObjectURL(pdfBlob);

            // Auto download
            const a = document.createElement('a');
            a.href = url;
            a.download = `${file.name.split('.')[0]}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            // Clear file selection after successful conversion
            setFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } catch (err) {
            console.error(err);
            setError('Error converting file. Please try again.');
        } finally {
            setConverting(false);
        }
    };

    return (
        <div className="converter-section">
            <h2>Image to PDF</h2>

            <div className="input-group">
                <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button
                onClick={handleConvert}
                disabled={converting || !file}
                className="convert-btn"
            >
                {converting ? 'Converting...' : 'Convert to PDF'}
            </button>

            {converting && <div className="loading-indicator">Processing...</div>}
        </div>
    );
};

export default ImageToPDF;
